import React, { useCallback, useEffect, useMemo, useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faChevronRight, faArrowLeft, faPlus} from '@fortawesome/fontawesome-free-solid/';
import i18next from 'i18next';

import ChecklistTaskStep from './checklist_task_step';

const StepMenuItem = ({ name, isSelected, onSelection }) => (
    <div>
        {
            isSelected ? 
            <div className="row" style={{backgroundColor: '#f7a701'}}>
                <button className="btn btn-basic btn-block corrective-action-button corrective-action-step-selected" onClick={onSelection}>
                    <div>
                        <span className="pull-left" style={{fontWeight: 'bold'}}>{name}</span>
                        <div className="pull-right"><FontAwesomeIcon icon={faChevronRight} /></div>
                    </div>
                </button>
            </div>
            :
            <div className="row">
                <button className="btn btn-block corrective-action-step-unselected" onClick={onSelection}> 
                    <div>
                        <span className="pull-left">{name}</span>
                    </div>
                </button>
            </div>
        }
    </div>
);

const ChecklistCorrectiveAction = ({ correctiveActionContext, readOnly, stepTypes, checklistDeviceTags, onDismiss, updateCorrectiveAction, inModal }) => {
    const correctiveAction = useMemo(() => correctiveActionContext.correctiveAction, [correctiveActionContext]);
    const selectedStep = useMemo(() => {
        if (correctiveActionContext.selectedStep) {
            return correctiveActionContext.selectedStep;
        } else {
            let steps = [...correctiveActionContext.correctiveAction.checklistTaskOptionConfigs];
            steps.sort((a, b) => { 
                return a.optionOrder - b.optionOrder;
            });
            return steps[0];
        }        
    }, [correctiveActionContext]);

    const addCorrectiveActionStep = useCallback(() => {
        let updatedSteps = correctiveAction.checklistTaskOptionConfigs ? [...correctiveAction.checklistTaskOptionConfigs] : [];

        const newStep = { uid: updatedSteps.length, name: "", optionOrder: updatedSteps.length };
        updatedSteps.push(newStep);
        updatedSteps.sort((a, b) => { 
            return a.optionOrder - b.optionOrder;
         });

        updateCorrectiveAction({
            ...correctiveActionContext,
            selectedStep: newStep,
            correctiveAction: {
                ...correctiveAction,
                checklistTaskOptionConfigs: updatedSteps
            },
        });
    }, [correctiveAction, updateCorrectiveAction]);

    const updateCorrectiveActionStep = useCallback((stepToUpdate) => {
        const updatedSteps = correctiveAction.checklistTaskOptionConfigs.map((step) => (step.uid === stepToUpdate.uid ? { ...stepToUpdate, errors: {} } : step));
        updatedSteps.sort((a, b) => { 
            return a.optionOrder - b.optionOrder ;
        });
                                                
        updateCorrectiveAction({ 
            ...correctiveActionContext, 
            selectedStep: stepToUpdate,
            correctiveAction: { 
                ...correctiveAction, 
                checklistTaskOptionConfigs: updatedSteps
            }
        });
    }, [correctiveAction, updateCorrectiveAction]);

    const removeCorrectiveActionStep = useCallback((stepToRemove) => {
        let updatedSteps = [...correctiveAction.checklistTaskOptionConfigs];
        updatedSteps.splice(updatedSteps.findIndex((step) => step.uid === stepToRemove.uid), 1);
        updatedSteps.sort((a, b) => { 
            return a.optionOrder - b.optionOrder;
        });

        var stepIndex = 0;
        updatedSteps = updatedSteps.map((step) => ({...step, uid:stepIndex++}));

        updateCorrectiveAction({
            ...correctiveActionContext,
            selectedStep: updatedSteps.length > 0 ? updatedSteps[0] : null,
            correctiveAction: {
                ...correctiveAction,
                checklistTaskOptionConfigs: updatedSteps
            }
        });
    }, [correctiveAction, updateCorrectiveAction]);

    const changeSelectedStep = useCallback((step) => {
        updateCorrectiveAction({
            ...correctiveActionContext,
            selectedStep: step
        });
    }, [correctiveAction, updateCorrectiveAction]);

    return (
        <div className="row checklist-corrective-action">
            <div className="row">
                <ul className="list-inline clearfix">
                    <li className="pull-left">
                        { inModal === true ? null : 
                            <button className="btn btn-sm btn-block corrective-action-button" onClick={onDismiss}>
                                <FontAwesomeIcon icon={faArrowLeft}/> {i18next.t('pages.checklists.back-to-steps')}
                            </button>
                        }
                    </li>
                    <li className="pull-right">
                        { !readOnly &&
                            <button className="btn btn-sm btn-default" onClick={addCorrectiveActionStep}><FontAwesomeIcon icon={faPlus} /> {i18next.t('pages.checklists.step')}</button>
                        }
                    </li>
                </ul>
                <span><h4>{i18next.t('form-labels.corrective-action')}: {correctiveAction.name}</h4></span>
            </div>

            <div className="row corrective-action-step-container">
                <div className="col-sm-4">
                    {
                        correctiveAction.checklistTaskOptionConfigs && 
                        <div>
                            { 
                                correctiveAction.checklistTaskOptionConfigs.map((step) => 
                                    <StepMenuItem
                                        key={step.uid ?? step.id} 
                                        name={step.name && step.name !== '' ? step.name : '----'} 
                                        isSelected={selectedStep && step.uid === selectedStep.uid}
                                        onSelection={() => changeSelectedStep(step)} 
                                    />
                                ) 
                            }
                        </div>
                    }
                </div>

                <div className="col-sm-8 corrective-action-details-box" style={{height: 600, overflow: "auto"}}>
                    { 
                        selectedStep &&
                        <ChecklistTaskStep 
                            stepTypes={stepTypes}
                            checklistDeviceTags={checklistDeviceTags}
                            step={selectedStep}
                            readOnly={readOnly}
                            onStepUpdate={updateCorrectiveActionStep}
                            onStepRemove={removeCorrectiveActionStep}
                            inCorrectiveAction={true}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default ChecklistCorrectiveAction;